import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e92aee50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "section1",
  class: "aboutLingBang"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "caption-en" }, "科技服务品牌-灵蚌科技", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "responsibility-desc" }, " 灵蚌科技为旗下科技服务品牌，为不良资产管理科技服务提供商，依托企业7年的不良资产处置行业积淀，以及机器学习科研团队、灵芯创新实验室的业务经验，在不断发展的过程中，凭借自身创新服务能力，为客户提供SAAS服务、金融科技服务等智能处置解决方案，满足合规与业务需求。 ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}